import React from "react";
import myCoinSvg from "/coinSOFT.svg";
import myCoinSvg1 from "/gemstone.svg";
import myCoinSvg2 from "/coinSCATTERED.svg";
import myCoinSvg9 from "/tokenization.svg";
import { cn } from "~/lib/utils";
import { CoinVertical, Coins } from "phosphor-react";
import CoinLeftSVG from "./coin-left-svg";

export default function CreditsButton({
  credits,
  onClick,
  showPlus,
}: {
  credits: number;
  onClick?: () => void;
  showPlus?: boolean;
}) {
  return (
    <div
      onClick={onClick}
      // Give the container a fixed size
      className={cn(
        "relative inline-flex items-center justify-center w-8 h-8 cursor-pointer transition-transform",
        credits < 10 ? "animate-pulsesubtle" : ""
      )}
    >
      {/* The coin fills the container */}

      {/* <img src={myCoinSvg9} alt="Coin" className="w-full h-full object-cover" /> */}

      {/* <img src={myCoinSvg2} alt="Coin" className="w-full h-full object-cover" /> */}
      {/* <img src={myCoinSvg1} alt="Coin" className="w-full h-full object-cover" /> */}
      {/* <CreditIconSVG className="w-full h-full text-amber-900 " /> */}
      {/* Sized by ink, not by box: this SVG's artwork fills 100% of its 512
          viewBox (no internal margin), so a 20px box draws 20px of coin —
          matching the ~20px the 24px line icons draw at ~81% fill. */}
      <CoinLeftSVG className="w-5 h-5" />

      {/* Badge pinned to top-right */}
      <span
        className={cn(
          "absolute md:-top-1 -top-0 left-6 transform ",
          "flex items-center justify-center h-4 min-w-[1.5rem]",
          "text-[0.6rem] font-bold border border-text1 rounded-full",
          "bg-background text-white leading-none",
          "px-0.5",
          credits < 50 ? "text-text" : "text-text"
        )}
      >
        {showPlus ? '+' : ''}{formatCredits(credits)}
      </span>
    </div>
  );
}

function formatCredits(credits: number): string {
  // If below 1000, just return the number
  if (credits < 1000) return credits.toString();

  // Otherwise, convert to e.g. 1.15 for 1150
  const thousands = credits / 1000;

  // Truncate to one decimal place:
  // e.g. 1.15 => floor(1.15 * 10) / 10 => 1.1
  const truncated = Math.floor(thousands * 10) / 10;

  // If truncated is an integer, remove the ".0"
  // e.g. 10.0 => "10"
  if (Number.isInteger(truncated)) {
    return truncated.toString().replace(".0", "") + "K";
  } else {
    return truncated.toString() + "K";
  }
}
